import { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export type TopLinedContainerProps = {
  children: ReactNode;
  classNames?: string;
  id?: string;
};

export const TopLinedContainer = ({
  children,
  classNames,
  id,
}: TopLinedContainerProps) => {
  return (
    <div className={clsx(styles.root, classNames)} id={id}>
      {children}
    </div>
  );
};
